module.exports = __webpack_public_path__ + "static/media/capot_2x.6fa9343d.svg";